<template>
  <div>
    <h3>Акт готовности ОО. Сводный отчет п.7</h3>
    <v-row align="center">
      <v-col cols="12" sm="2">
        <v-select
          :items="years"
          v-model="year"
          label="Выберите год"
          variant="underlined"
        >
        </v-select>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn
          color="success"
          variant="text"
          icon="mdi-file-excel"
          @click="getReport"
        ></v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      years: [2020, 2021, 2022],
      year: "2021",
    };
  },
  created() {},
  methods: {
    getReport() {
      document.location.href =
        this.$model.wwwroot +
        "/report/minobr/index.php/akt/print_akt?year=" +
        this.year;
    },
  },
};
</script>
